import { Breakpoint } from './breakpoints';

export const tableMedia = {
  mediaMaxWidthForMobile: `(max-width: ${Breakpoint.Sm - 1}px)`,
  mediaMinWidthForTabletAndDesktop: `(min-width: ${Breakpoint.Sm}px)`
};
